import React from "react";
import { Tooltip } from "@mhome/ui";

const PromptDisplay = ({ text }) => {
  const parts = [];
  let lastIndex = 0;

  // Match entity tags with attributes
  const entityRegex = /<entity\s+([^>]*?)(?:\s*\/)?>\s*(?:<\/entity>)?/g;
  let match;

  while ((match = entityRegex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(
        <span key={`text-${lastIndex}`}>
          {text.substring(lastIndex, match.index)}
        </span>
      );
    }

    // Parse attributes from the entity tag
    const attributes = match[1];
    const typeMatch = attributes.match(/type\s*=\s*["']([^"']*?)["']/);
    const nameMatch = attributes.match(/name\s*=\s*["']([^"']*?)["']/);
    const typeNameMatch = attributes.match(/typeName\s*=\s*["']([^"']*?)["']/);

    const entityType = typeMatch ? typeMatch[1] : "";
    const entityName = nameMatch ? nameMatch[1] : "";
    const entityTypeName = typeNameMatch ? typeNameMatch[1] : entityType; // fallback to type if typeName not found

    const prefix = `@${entityTypeName}:`;
    const maxContentLength = 20; // Reduced for better fit
    const isContentTruncated = entityName.length > maxContentLength;
    const truncatedContent = isContentTruncated
      ? entityName.substring(0, maxContentLength - 3) + "..."
      : entityName;

    const chipContent = (
      <span
        key={match.index}
        style={{
          display: "inline-flex",
          alignItems: "center",
          maxWidth: "200px", // Prevent overflow
          minWidth: 0, // Allow shrinking
          marginLeft: "4px",
          marginRight: "4px",
          paddingLeft: "8px",
          paddingRight: "8px",
          paddingTop: "2px",
          paddingBottom: "2px",
          borderRadius: "16px",
          fontSize: "0.75rem",
          lineHeight: 1.2,
          backgroundColor:
            typeof document !== "undefined" &&
            document.documentElement.classList.contains("dark")
              ? "#4F6B80"
              : "#E3F2FD",
          color: "hsl(var(--primary-foreground))",
          fontWeight: 500,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        <span
          style={{
            color:
              typeof document !== "undefined" &&
              document.documentElement.classList.contains("dark")
                ? "#BFDBFE"
                : "#1976D2",
            fontWeight: 600,
            flexShrink: 0, // Don't shrink the prefix
          }}
        >
          {prefix}
        </span>
        <span
          style={{
            color:
              typeof document !== "undefined" &&
              document.documentElement.classList.contains("dark")
                ? "#BFDBFE"
                : "#1976D2",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minWidth: 0, // Allow shrinking
          }}
        >
          {truncatedContent}
        </span>
      </span>
    );

    // Add tooltip if content is truncated
    if (isContentTruncated) {
      parts.push(
        <Tooltip key={match.index} title={`${prefix}${entityName}`} arrow>
          {chipContent}
        </Tooltip>
      );
    } else {
      parts.push(chipContent);
    }

    lastIndex = entityRegex.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(
      <span key={`text-${lastIndex}`}>{text.substring(lastIndex)}</span>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        minWidth: 0, // Allow the container to shrink
        width: "100%",
        gap: "4px",
      }}
    >
      {parts}
    </div>
  );
};

export default PromptDisplay;
